export enum HealthProfileUpdateStepNames {
  SelectTakingMedications = 'select_medications',
  SearchMedications = 'search_medications',
  ConfirmMoveMedications = 'confirm_move_medications',
  Confirmation = 'confirmation',
  GotIt = 'updated',
  PharmacySearch = 'pharmacy',
  JustSayCapsule = 'tell_your_doctor',
}
